import { SM_THEME as T } from './stateMachineTheme'
import { OutputPins } from './smPins'
import { selectedBorder } from './selectedBorder.js'

export function EntryNode({ selected }) {
  return (
    <div style={{
      background: T.entryBg,
      border: `2px solid ${selected ? selectedBorder(T.entryBorder) : T.entryBorder}`,
      borderRadius: 20,
      padding: '7px 18px',
      color: T.entryText,
      fontFamily: 'var(--m-font)',
      fontSize: 11,
      fontWeight: 'bold',
      letterSpacing: 1,
      whiteSpace: 'nowrap',
      userSelect: 'none',
    }}>
      ENTRY
      {/* ENG-1072: entry has no inputs, but its wire flips sides like any
          other so it can sit to the right of the state it starts. */}
      <OutputPins />
    </div>
  )
}
